import CartError from './CartError';

export default class ItemUnavailableError extends CartError {

  /** @type {string} */
  #itemTitle;

  /**
   * @param {string} itemTitle 
   */
  constructor(itemTitle) {
    super('Item does not have enough stock');

    this.#itemTitle = itemTitle;
  }

  get itemTitle() {
    return this.#itemTitle;
  }
}